export interface RecipeDiary {
  RecipeDiaryId: string;
  CustomerId: string;
  RecipeHeaderId: string;
  ActionType: number;
  ActionSummary: string;
  AdditionalData: string;
  ChangeByUser: string;
  CreateDate: Date | string;
  ChangeDate: Date | string;
  DeleteDate?: Date | string;
}

export type GetRecipeDiariesRequest = {
  CustomerId: string;
  RecipeHeaderId?: string;
  ActionType?: number;
  StartDate: Date | string;
  EndDate: Date | string;
};

export type RevertRecipeDiaryActionRequest = {
  RecipeDiaryId: string;
};

export enum RecipeDiaryActionType {
  RecipeHeader_Add = 0,
  RecipeHeader_Update = 1,
  RecipeHeader_Remove = 2,

  RecipeDetail_Add = 3,
  RecipeDetail_Update = 4,
  RecipeDetail_Remove = 5,

  RecipeHeaderPrivateUser_Add = 6,
  RecipeHeaderPrivateUser_Remove = 7,

  RecipeHeader_Recover = 8,
  RecipeDetail_Sequence = 9,
}
